import { takeLatest, all } from "redux-saga/effects";
import API from "../../services/Api";
import { MergeCmsTypes } from "../reducers/MergeCmsRedux";
import { getMergeCmsData } from "./MergeCmsSagas";

const api = API.create();

export default function* root() {
  yield all([
    takeLatest(MergeCmsTypes.MERGE_CMS_DATA_REQUEST, getMergeCmsData, api),
  ]);
}
